/**
 * Validación de RUT en el navegador — espejo de `backend/src/utils/rut.ts`.
 * Sirve para avisar antes de enviar el formulario de reserva; la validación
 * que manda sigue siendo la del servidor.
 */

export function computeDv(body: string): string {
  let sum = 0
  let multiplier = 2
  for (let i = body.length - 1; i >= 0; i--) {
    sum += Number(body[i]) * multiplier
    multiplier = multiplier === 7 ? 2 : multiplier + 1
  }
  const remainder = 11 - (sum % 11)
  if (remainder === 11) return '0'
  if (remainder === 10) return 'K'
  return String(remainder)
}

export function normalizeRut(input: string): string | null {
  const clean = input.replace(/[.\s-]/g, '').toUpperCase()
  if (!/^\d{7,8}[\dK]$/.test(clean)) return null
  return `${clean.slice(0, -1)}-${clean.slice(-1)}`
}

export function isValidRut(input: string): boolean {
  const normalized = normalizeRut(input)
  if (!normalized) return false
  const [body, dv] = normalized.split('-')
  return computeDv(body) === dv
}

/** "123456785" → "12.345.678-5" mientras se escribe (sin exigir el DV todavía). */
export function formatRutInput(input: string): string {
  const clean = input.replace(/[^0-9kK]/g, '').toUpperCase().slice(0, 9)
  if (clean.length < 2) return clean
  const body = clean.slice(0, -1)
  const dv = clean.slice(-1)
  return `${Number(body).toLocaleString('es-CL')}-${dv}`
}

export function isValidPassport(input: string): boolean {
  return /^[A-Z0-9]{5,12}$/.test(input.replace(/[^A-Za-z0-9]/g, '').toUpperCase())
}
